import moment from 'moment';

import { DATE_FORMAT } from '../constants';

export const formatToDate = (date?: string) => {
  if (date) {
    return moment(date).format(DATE_FORMAT);
  }
};
